import React from "react";
import {
  RiArchiveStackLine,
  RiBarChartGroupedLine,
  RiBarChartLine,
  RiDashboardLine,
  RiFileList3Line,
  RiFireLine,
  RiLockLine,
  RiPieChartLine,
  RiShoppingBag3Line,
  RiStackLine,
  RiStockLine,
  RiTimeLine,
  RiUserLine,
  RiWalletLine,
} from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import NavItem from "./NavItem";
import { usePermission } from "../hooks/usePermission";

const SuperMarcketMenu = ({ page }) => {
  const navigate = useNavigate();
  const { hasPageAccess } = usePermission();

 
  

  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo"));
  const vansale = adminInfo?.vansale;
  const permission = adminInfo?.permission;
  const allowedPageIds = permission?.map((p) => p.submenuPageId) || [];

  return (
    <>
      {hasPageAccess("insight") && (
        <NavItem
          icon={<RiPieChartLine />}
          title="Insight"
          path="/dashboard"
          navigateTo={navigate}
          active={page === "Insight"}
          submenuPageId={"0"}
        />
      )}

      {hasPageAccess("departmentwisesales") && (
        <NavItem
          icon={<RiDashboardLine />}
          title="Department wise Sales"
          path="/dept-sales"
          navigateTo={navigate}
          active={page === "Department wise Sales"}
          submenuPageId={"6"}
        />
      )}

      {hasPageAccess("hourlysales") && (
        <NavItem
          icon={<RiTimeLine />}
          title="Hourly Sales"
          path="/hourly-sales"
          navigateTo={navigate}
          active={page === "Hourly Sales"}
          submenuPageId={"7"}
        />
      )}

      {hasPageAccess("topsellingproducts") && (
        <NavItem
          icon={<RiFireLine />}
          title="Top Selling Products"
          path="/top-products"
          navigateTo={navigate}
          active={page === "Top Selling Products"}
          submenuPageId={"8"}
        />
      )}

      {hasPageAccess("invoicewisesales") && (
        <NavItem
          icon={<RiFileList3Line />}
          title="Invoice wise Sales"
          path="/invoice-sales"
          navigateTo={navigate}
          active={page === "Invoice wise Sales"}
          submenuPageId={"9"}
        />
      )}

      {hasPageAccess("salesmanwisesales") && (
        <NavItem
          icon={<RiBarChartLine />}
          title="Salesman wise Sales"
          path="/salesman-sales"
          navigateTo={navigate}
          active={page === "Salesman wise Sales"}
          submenuPageId={"10"}
        />
      )}

      {hasPageAccess("stockreport") && (
        <>
          <NavItem
            icon={<RiStockLine />}
            title="Department Wise Stock"
            path="/stock-report"
            navigateTo={navigate}
            active={page === "Department Wise Stock"}
            submenuPageId={"9"}
          />
          <NavItem
            icon={<RiArchiveStackLine />}
            title="Department Wise Stock With Products"
            path="/stock-report-with-products"
            navigateTo={navigate}
            active={page === "Department Wise Stock With Products"}
            submenuPageId={"9"}
          />
        </>
      )}
      {hasPageAccess("productslist") && (
        <>
          <NavItem
            icon={<RiShoppingBag3Line />}
            title="Products List"
            path="/products-list"
            navigateTo={navigate}
            active={page === "Products List"}
            submenuPageId={"9"}
          />
         
        </>
      )}
      {hasPageAccess("reorder") && (
        <>
          <NavItem
            icon={<RiStackLine />}
            title="Reorder"
            path="/reorder"
            navigateTo={navigate}
            active={page === "Reorder"}
            submenuPageId={"9"}
          />
         
        </>
      )}
      {hasPageAccess("dayclosecash") && (
        <>
          <NavItem
            icon={<RiWalletLine />}
            title="Day Close Cash Difference"
            path="/day-close-cash"
            navigateTo={navigate}
            active={page === "Day Close Cash"}
            submenuPageId={"9"}
          />
         
        </>
      )}

      <NavItem
        icon={<RiUserLine />}
        title="Users List"
        path="/users-list"
        navigateTo={navigate}
        active={page === "Users List"}
        submenuPageId={1}
        show={allowedPageIds.includes("1")}
      />
      <NavItem
        icon={<RiLockLine />}
        title="Users Permission"
        path="/users-permission"
        navigateTo={navigate}
        active={page === "Users Permission"}
        submenuPageId={2}
        show={allowedPageIds.includes("2")}
      />
      {vansale === 1 && (
        <NavItem
          icon={<RiDashboardLine />}
          title="Van Sale"
          path="/van-sale"
          navigateTo={navigate}
          active={page === "Van Sale"}
          submenuPageId={"11"}
        />
      )}
    </>
  );
};

export default SuperMarcketMenu;
